import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { clinicsIn } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getSouthStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics in the South", "/locations/restore-south/", clinicsIn("dallas", "charlotte")),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "South", path: "/locations/restore-south/" },
    ]),
  ];
}
